import { render, staticRenderFns } from "./Look.vue?vue&type=template&id=2beac457&scoped=true"
import script from "./Look.vue?vue&type=script&lang=js"
export * from "./Look.vue?vue&type=script&lang=js"
import style0 from "./Look.vue?vue&type=style&index=0&id=2beac457&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beac457",
  null
  
)

export default component.exports